import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import {
  DYNAMIC_LINK_TAPPED,
  DYNAMIC_LINK_CREATE,
  DYNAMIC_LINK_CREATE_ERROR,
  DYNAMIC_LINK_CREATE_SUCCESS
} from "./messageTypes";

const dynamicLinks =
  window.cordova &&
  window.cordova.plugins &&
  window.cordova.plugins.firebase &&
  window.cordova.plugins.firebase.dynamiclinks;

if (dynamicLinks) {
  dynamicLinks.onDynamicLink(data => {
    console.log("onDynamicLink", data);
    sendMessageToWebApp(DYNAMIC_LINK_TAPPED, { data });
  });

  onMessageFromWebApp(DYNAMIC_LINK_CREATE, async ({ type, parameters }) => {
    try {
      let dynamicLinkUrl;
      if (type === "short") {
        dynamicLinkUrl = await dynamicLinks.createShortDynamicLink(parameters);
      } else if (type === "unguessable") {
        dynamicLinkUrl = await dynamicLinks.createUnguessableDynamicLink(parameters);
      } else {
        dynamicLinkUrl = await dynamicLinks.createDynamicLink(parameters);
      }
      sendMessageToWebApp(DYNAMIC_LINK_CREATE_SUCCESS, { url: dynamicLinkUrl });
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(DYNAMIC_LINK_CREATE_ERROR, { error });
    }
  });
}
